import { useSelector } from 'react-redux';
import { selectAllCompanies } from 'redux/companies/companiesSlice';
import { selectAllLanguages } from 'redux/contacts/languagesSlice';
import { selectAllContactTypes } from 'redux/contactTypes/contactTypesSlice';
import { makeAddressForm } from 'containers/pages/contacts/libs';
import * as TY from 'containers/pages/contacts/constants';

/**
 * @function useContactForm
 * @param {function} dispatch
 * @param {string} addressType
 * @returns {object}
 */
function useContactForm(dispatch, addressType) {
	const { companies } = useSelector(selectAllCompanies);
	const { contactTypes } = useSelector(selectAllContactTypes);
	const { languages } = useSelector(selectAllLanguages);

	const handlePlace = (placeData, _addressType) => {
		const madeAddressForm = makeAddressForm(placeData);

		if (addressType === TY.ADDRESS_WORK) {
			madeAddressForm.type = '4';
		} else if (addressType === TY.ADDRESS_HOME) {
			madeAddressForm.type = '5';
		} else if (addressType === TY.ADDRESS_OTHER) {
			madeAddressForm.type = '6';
		}
		dispatch({ type: addressType, payload: madeAddressForm });
	};

	return { companies, contactTypes, languages, handlePlace };
}

export default useContactForm;
